import { useAppStore } from "@hooks/useAppStore";
import { isDev } from "@memorang/constants/urls";

export const getClerkPublishableKey = () => {
	const app = useAppStore.getState().app;
	const publishableKey = isDev
		? app.keys.clerk?.publishableKeyDev
		: app.keys.clerk?.publishableKeyProd;
	if (!publishableKey) {
		throw new Error("Clerk publishable key not found");
	}
	return publishableKey;
};
